import { Component } from '@angular/core';
import { BaseCustomComponent } from '../base-custom.component';

@Component({
  selector: 'test-component',
  template: `
		<p>Test component</p>
		<pre>{{this.form?.value | json}}</pre>
	`
})
export class TestComponent extends BaseCustomComponent {
  constructor() {
    super();
  }
}